
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import axios from "axios";
import './registerServiceWorker';

// import VueNativeSock from "vue-native-websocket";
require("@/assets/css/page.scss");
require("@/assets/css/admin.scss");
require("@/assets/css/tooltip.css");
require("@/assets/css/notification.scss");
require("vue-multiselect/dist/vue-multiselect.min.css");

import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faCoffee, faCheck, faUser, faCalendarWeek, faClipboardCheck,
    faCalendarCheck, faHome, faCheckSquare, faToolbox,
    faUserCircle, faSearch, faArrowLeft, faClock, faEnvelope,
    faMobile, faTrash, faInfoCircle, faPlug, faLock, faLockOpen, faUsers
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import draggable from "vuedraggable";
import ToggleButton from "vue-js-toggle-button";
import { VTooltip, VPopover, VClosePopover } from "v-tooltip";
import PrettyCheckbox from "pretty-checkbox-vue";
import VueFlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Swatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.min.css";
import Notifications from "vue-notification";
import icons from "vue-icon";
import Multiselect from "vue-multiselect";
import Axios from "axios";



import VueFab from 'vue-float-action-button'

import { authService } from "@/services/auth.service";




Vue.config.productionTip = false;

library.add(faCoffee, faCheck, faUser, faCalendarWeek, faClipboardCheck, faCalendarCheck, faHome,
    faCheckSquare, faToolbox, faUserCircle, faSearch, faArrowLeft, faClock, faEnvelope, faMobile,
    faTrash, faInfoCircle, faPlug, faLock, faLockOpen, faUsers);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("draggable", draggable);
Vue.directive("tooltip", VTooltip);
Vue.directive("close-popover", VClosePopover);
Vue.component("v-popover", VPopover);
Vue.component("swatches", Swatches);
Vue.use(VueFlatPickr);
Vue.use(ToggleButton);
Vue.use(PrettyCheckbox);
Vue.use(Notifications);
Vue.use(icons, "v-icon");
Vue.use(VueFab,
    {
        //----------------------
        // opitons 可选iconfont图标或MaterialIcons
        iconType: 'MaterialDesign'
        // iconType: 'iconfont'
    }
)

// register globally
Vue.component("multiselect", Multiselect);

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");



axios.interceptors.request.use(async (config: any) => {
    const authToken = store.getters["auth/authToken"];
    const companyId = store.getters["auth/companyId"];
    store.dispatch("app/setLoading", true);
    if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
        config.headers.Company = companyId;
    }
    return config;
});

// , (error: any) => {
//   if (error.response.data.error.statusCode === 401 || error.response.data.error.statusCode === 405) {
//       store.dispatch("auth/refresh").then((result) => {

//       },
//       (error) => {


//       });

//       store.dispatch("auth/authLogout");


//       router.push("/login");
//   }
//   return Promise.reject(error);
// }

axios.interceptors.response.use((response: any) => {
    store.dispatch("app/setLoading", false);
    return response;
}, error => {
    store.dispatch("app/setLoading", false);
    const status = error.response ? error.response.status : null;

    if (status === 401) {
        return refreshToken().then((_: any) => {

            error.config.headers['Authorization'] = 'Bearer ' + store.getters["auth/authToken"];
            error.config.baseURL = undefined;
            return axios.request(error.config);
        }, (error: any) => {
            store.dispatch("auth/authLogout");
            router.push("/login");
        });
    } else {
        store.dispatch("app/addErrors", JSON.stringify(error.response.data.errors));
    }

    return Promise.reject(error);
});

function refreshToken() {
    if (store.getters["auth/isRefreshing"]) {
        return store.getters["auth/refreshingCall"];
    }

    const refreshingCall = store.dispatch("auth/refresh");

    // const refreshingCall = Axios.get('get token').then(({ data: { token } }) => {
    //     store.commit('auth/setToken', token)
    //     store.commit('auth/setRefreshingState', false);
    //     store.commit('auth/setRefreshingCall', undefined);
    //     return Promise.resolve(true);
    // });

    // });

    store.commit('auth/mSetRefreshingCall', refreshingCall);
    return refreshingCall;
}

// axios.interceptors.response.use((config:any, error:any) => {
//   store.dispatch("app/resetErrors");
//   store.dispatch("app/setLoading", false);
//   if (config.status === 401 || config.status === 405) {
//     store.dispatch("auth/refresh").then((result) => {
//       axios.request(error.config);
//     },
//     (error) => {
//       store.dispatch("auth/authLogout");
//       router.push("/login");
//       return Promise.reject(config);
//     });

//   }
//   return config;
// }
//     , (error: any) => {
//     store.dispatch("app/addErrors", JSON.stringify(error.response.data.errors));
//     store.dispatch("app/setLoading", false);
//     if (error.response.status === 401 || error.response.status === 405) {
//         store.dispatch("auth/authLogout");
//         router.push("/login");
//     }
//     // alert("teet");
//     return (error);
// }
// );
